import './ProductListing.scss';
import { StringFormatter } from '@gplibraries/utils';
import { ResponsiveGrid, Icon } from '@gplibraries/react/components';
import { useBreakpoint } from '@gplibraries/react/hooks';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function ProductListing(props) {

  const { product } = props;
  const isMobile = useBreakpoint();

  return (
    <section className={'block shadow full product-listing-container'}>

      {product.field_condition_of_unit &&
      <div className={'product-description'}>
        {parse(DOMPurify.sanitize(product.field_condition_of_unit?.processed))}
      </div>
      }

      <div className="block flashcard full border">

        <h2>Product Details</h2>

        <table className={'nostyle product-details'}>
          <tbody>
            <tr>
              <th>Model:</th>
              <td>{product.title}</td>
            </tr>

            {product.field_serial_number &&
            <tr>
              <th>S/N:</th>
              <td>{product.field_serial_number}</td>
            </tr>
            }

            <tr>
              <th>Unit Category:</th>
              <td>{product.field_unit_category.name}</td>
            </tr>

            {product.field_location &&
            <tr>
              <th>Location:</th>
              <td>{product.field_location}</td>
            </tr>
            }

            {product.field_quantity &&
            <tr>
              <th>Quantity Available:</th>
              <td>{product.field_quantity}</td>
            </tr>
            }

            {product.field_discount_available &&
            <tr>
              <th>Discount Available:</th>
              <td>{product.field_discount_available}</td>
            </tr>
            }

            {product.field_list_price &&
            <tr>
              <th>MSRP:</th>
              <td>{StringFormatter.currency(product.field_list_price)}</td>
            </tr>
            }

            {product.field_dealer_net &&
            <tr>
              <th>Dealer Net:</th>
              <td>{StringFormatter.currency(product.field_dealer_net)}</td>
            </tr>
            }

            {product.field_current_bid &&
            <tr>
              <th>Current Bid:</th>
              <td>{StringFormatter.currency(product.field_current_bid)}</td>
            </tr>
            }

            {product.field_starting_bid &&
            <tr>
              <th>Starting Bid:</th>
              <td>{StringFormatter.currency(product.field_starting_bid)}</td>
            </tr>
            }

            {product.field_is_reserve_met &&
            <tr>
              <th>Reserve Met:</th>
              <td>{product.field_is_reserve_met === true ? 'YES' : 'NO'}</td>
            </tr>
            }

            {product.field_warranty_short &&
            <tr>
              <th>Warranty:</th>
              <td>{product.field_warranty_short}</td>
            </tr>
            }

            {product.field_closing_date &&
            <tr>
              <th>Closing Date (CST):</th>
              <td>{new Date(product.field_closing_date).toLocaleString()}</td>
            </tr>
            }
          </tbody>
        </table>

      </div>

      {product.field_images?.length > 0 && <>
        <h2>Images</h2>
        <ResponsiveGrid columnWidth={isMobile ? '160px' : '300px'} gap={16}>
          {product.field_images.map(img =>
            <div key={img.id} className={'product-image-container flex-col'}>
              <a href={img.uri} className={'image-expand'} target={'_blank'}>
                <Icon glyph={'box-arrow-up-right'}/>
              </a>
              <img src={img.image_styles.large}/>
            </div>
          )}
        </ResponsiveGrid>
      </>}

    </section>
  );

}